(function () {
  'use strict';

  var i18n = window.DZN_I18N || {};
  var routes = window.DZN_ROUTES || {};
  var CART_URL = routes.cart || '/cart';
  var CART_ADD_URL = routes.cartAdd || '/cart/add';
  var CART_CHANGE_URL = routes.cartChange || '/cart/change';
  var T_EMPTY = i18n.empty || 'Tu carrito está vacío.';
  var T_REMOVE = i18n.remove || 'Quitar';
  var T_ADDING = i18n.adding || 'Agregando...';

  function startClock() {
    var nodes = document.querySelectorAll('[data-dzn-clock]');
    if (!nodes.length) return;
    var tz = 'Asia/Makassar';
    var zone = 'Bali, ID';
    var locale = document.documentElement.lang || 'en';

    function tick() {
      var now = new Date();
      var time = new Intl.DateTimeFormat('en-GB', { timeZone: tz, hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }).format(now);
      var day = new Intl.DateTimeFormat(locale, { timeZone: tz, weekday: 'long' }).format(now);
      var date = new Intl.DateTimeFormat('en-GB', { timeZone: tz, day: '2-digit', month: '2-digit', year: '2-digit' }).format(now).replace(/\//g, '.');

      nodes.forEach(function (node) {
        var t = node.querySelector('[data-dzn-clock-time]');
        var d = node.querySelector('[data-dzn-clock-date]');
        if (t) t.textContent = time + ' ' + zone;
        if (d) d.textContent = day.charAt(0).toUpperCase() + day.slice(1) + ', ' + date;
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  function initCompare(root) {
    var range = root.querySelector('input[type="range"]');
    var after = root.querySelector('.dzn-compare__after');
    var divider = root.querySelector('.dzn-compare__divider');
    if (!range || !after || !divider) return;

    function apply(value) {
      after.style.clipPath = 'inset(0 0 0 ' + value + '%)';
      divider.style.left = value + '%';
    }
    apply(range.value);
    range.addEventListener('input', function () { apply(range.value); });

    var dragging = false;
    function fromEvent(e) {
      var rect = root.getBoundingClientRect();
      var x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
      var pct = Math.max(0, Math.min(100, (x / rect.width) * 100));
      range.value = pct;
      apply(pct);
    }
    root.addEventListener('pointerdown', function (e) { dragging = true; fromEvent(e); });
    window.addEventListener('pointermove', function (e) { if (dragging) fromEvent(e); });
    window.addEventListener('pointerup', function () { dragging = false; });
  }

  function initMarquee(track) {
    if (track.dataset.dznCloned === 'true') return;
    track.innerHTML = track.innerHTML + track.innerHTML;
    track.dataset.dznCloned = 'true';
  }

  var money = window.DZN_MONEY_FORMAT || '${{amount}}';

  function group(intPart, sep) {
    return intPart.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    return money
      .replace('{{amount}}', group(parts[0], ',') + '.' + parts[1])
      .replace('{{amount_with_comma_separator}}', group(parts[0], '.') + ',' + parts[1])
      .replace('{{amount_no_decimals}}', group(parts[0], ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', group(parts[0], '.'));
  }

  function drawer() { return document.querySelector('[data-dzn-drawer]'); }

  function openDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderCart(cart) {
    document.querySelectorAll('[data-dzn-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
    });
    var body = document.querySelector('[data-dzn-drawer-body]');
    var total = document.querySelector('[data-dzn-drawer-total]');
    var foot = document.querySelector('[data-dzn-drawer-foot]');
    if (!body) return;

    if (!cart.items.length) {
      body.innerHTML = '<p class="dzn-empty">' + escapeHtml(T_EMPTY) + '</p>';
      if (foot) foot.style.display = 'none';
      return;
    }
    if (foot) foot.style.display = '';

    body.innerHTML = cart.items.map(function (item) {
      var img = item.image ? '<img src="' + item.image + '" alt="" width="64" height="64">' : '';
      return '<div class="dzn-line">' + img +
        '<div><div class="dzn-line__title">' + escapeHtml(item.product_title) + '</div>' +
        '<div class="dzn-line__meta">' + formatMoney(item.final_line_price) + ' · x' + item.quantity + '</div>' +
        '<button type="button" class="dzn-line__remove" data-dzn-remove="' + item.key + '">' + escapeHtml(T_REMOVE) + '</button>' +
        '</div></div>';
    }).join('');

    if (total) total.textContent = formatMoney(cart.total_price);
  }

  function fetchCart() {
    return fetch(CART_URL + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function addToCart(variantId, quantity) {
    return fetch(CART_ADD_URL + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
    }).then(function (r) { return r.json(); });
  }

  function changeQty(key, quantity) {
    return fetch(CART_CHANGE_URL + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  function boot() {
    startClock();
    document.querySelectorAll('.dzn-compare').forEach(initCompare);
    document.querySelectorAll('[data-dzn-marquee-track]').forEach(initMarquee);

    document.addEventListener('click', function (e) {
      var open = e.target.closest('[data-dzn-cart-open]');
      if (open) { e.preventDefault(); fetchCart().then(openDrawer); return; }

      var close = e.target.closest('[data-dzn-cart-close]');
      if (close) { e.preventDefault(); closeDrawer(); return; }

      var remove = e.target.closest('[data-dzn-remove]');
      if (remove) { e.preventDefault(); changeQty(remove.getAttribute('data-dzn-remove'), 0); return; }

      var add = e.target.closest('[data-dzn-add]');
      if (add) {
        e.preventDefault();
        var id = add.getAttribute('data-dzn-add');
        var label = add.textContent;
        add.disabled = true;
        add.textContent = T_ADDING;
        addToCart(id, 1).then(function () {
          return fetchCart();
        }).then(function () {
          add.disabled = false;
          add.textContent = label;
          openDrawer();
        }).catch(function () {
          add.disabled = false;
          add.textContent = label;
        });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    if (document.querySelector('[data-dzn-drawer]')) fetchCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
